<template>
  <div>
    <el-card>
      <div slot="header" class="clearfix">
        <span style="color: #409EFF">店铺管理</span>
      </div>
      <el-button type="primary" size="small" style="margin: 0 0 10px 20px;"
                 icon="el-icon-plus" @click="handleAdd('新增绑定店铺')">新增绑定店铺
      </el-button>
      <el-table :data="tableData"
                ref="table"
                border default-expand-all stripe
                :max-height="tableHeight"
                :header-cell-style="{'text-align':'center'}"
                :cell-style="{'text-align':'center'}"
                style="margin-bottom: 20px;">
        <el-table-column prop="shopName" label="店铺名称(不可修改)"/>
        <el-table-column prop="shopType" label="店铺类型"/>
        <el-table-column prop="address" label="发货地址"/>
        <el-table-column prop="shopGroup" label="店铺组"/>
        <el-table-column prop="reviewStatus" label="审核状态"/>
        <el-table-column prop="dateValid" width="160" label="授权有效期">
          <template slot-scope="scope">
            <span v-if="scope.row.shopTypeId == 1">
              {{scope.row.dateValid}}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="remarks" label="备注"/>
        <el-table-column label="操作" width="260" align="center">
          <template slot-scope="scope">
            <el-button v-if="scope.row.status != 2" size="mini" type="primary" icon="el-icon-edit"
                       @click="locationHandleEdit(scope.$index, scope.row, '修改店铺信息')">
              修改提交
            </el-button>
            <el-button v-else size="mini" type="primary" icon="el-icon-view"
                       @click="locationHandleEdit(scope.$index, scope.row, '查看店铺信息')">
              查看
            </el-button>
            <el-button v-show="scope.row.shopTypeId == 1" type="primary" size="mini" @click="confirmAsscetAuthor">插旗授权</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible">
      <el-form :model="dialogForm" ref="dialogForm" :rules="dialogFormRules" label-width="120px">
        <el-row :gutter="2">
          <el-col :span="11">
            <el-form-item label="店铺类型" prop="shopTypeId">
              <el-select v-model="dialogForm.shopTypeId" clearable placeholder="请选择店铺类型" :disabled="dialogForm.status == 2">
                <el-option
                    v-for="item in ShopOptions"
                    :key="item.id"
                    :label="item.shopType"
                    :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="11" style="text-align: right">
            <el-form-item label="主营类目" prop="shopMajorTypeId">
              <el-select v-model="dialogForm.shopMajorTypeId" clearable placeholder="请选择主营类目" :disabled="dialogForm.status == 2">
                <el-option
                    v-for="item in majorTypeOptions"
                    :key="item.id"
                    :label="item.majorType"
                    :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="2">
          <el-col :span="11">
            <el-form-item label="抖音号" prop="shopUsername" v-if="dialogForm.shopTypeId==5">
              <el-input v-model="dialogForm.shopUsername" placeholder="请输入抖音号" :disabled="dialogForm.status == 2"></el-input>
            </el-form-item>
            <el-form-item label="店铺掌柜号" prop="shopUsername" v-else>
              <el-input v-model="dialogForm.shopUsername" placeholder="输入店铺掌柜号" :disabled="dialogForm.status == 2"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="店铺名称" prop="shopName">
              <el-input v-model="dialogForm.shopName" placeholder="店铺名称" :disabled="dialogForm.status == 2"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="2">
          <el-col :span="22">
            <el-form-item label="店铺链接" prop="shopUrl">
              <el-input v-model="dialogForm.shopUrl" placeholder="请输入店铺链接" :disabled="dialogForm.status == 2"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider></el-divider>
        <el-row :gutter="10" v-show="dialogForm.shopTypeId == 1">
          <el-col :span="12">
                <el-form-item label="交易备注" prop="tradeMemo">
                  <el-input v-model="dialogForm.tradeMemo" placeholder="交易备注"></el-input>
                </el-form-item>
              </el-col>
          <el-col :span="12">
                <el-form-item label="旗帜颜色" prop="tradeFlag">
                  <el-select v-model="dialogForm.tradeFlag" clearable placeholder="请选择">
                    <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
        </el-row>
        <el-row :gutter="2" v-show="dialogForm.shopTypeId == 1">
          <el-col :span="24">
          <span style="color: red;margin-left: 6%;padding-bottom: 2%;">
            使用淘宝工具之前请咨询使用方法， 并确认授权。（注：请使用绑定的淘宝商家的账号）
          </span>
          </el-col>
        </el-row>
        <el-row :gutter="2" style="margin-top: 2%;">
          <el-col :span="22">
            <el-form-item label="店铺组别" prop="shopGroup">
              <el-input v-model="dialogForm.shopGroup" placeholder="店铺组别"></el-input>
            </el-form-item>
          </el-col>
          <!--<el-col :span="11" v-show="false">
            <el-form-item label="复购天数" prop="rebuyDays">
              <el-input v-model="dialogForm.rebuyDays" placeholder="复购天数"></el-input>
            </el-form-item>
          </el-col>-->
        </el-row>
        <el-row :gutter="2">
          <el-col :span="22">
            <span style="color: red;margin-left: 6%;">（注:同类目店铺的后台风控组别，帮助您更好地避免买手交叉操作）</span>
          </el-col>
        </el-row>
        <el-divider></el-divider>
        <el-row :gutter="2">
          <el-col :span="11">
            <el-form-item label="发货联系人" prop="persionName">
              <el-input v-model="dialogForm.persionName" placeholder="请输入联系人姓名"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="发货电话" prop="persionPhone">
              <el-input v-model="dialogForm.persionPhone" placeholder="请输入联系人电话"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="2">
          <el-col :span="22">
            <el-form-item label="邮编" prop="persionZip">
              <el-input v-model="dialogForm.persionZip" placeholder="请输入邮编"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="2">
          <el-col :span="22">
            <el-form-item label="发货地址" prop="address">
              <template slot-scope="scope">
                <v-distpicker :province="dialogForm.province" :city="dialogForm.city" :area="dialogForm.area"
                              @selected="onSelected"></v-distpicker>
              </template>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="2">
          <el-col :span="22">
            <el-form-item prop="detailAddress">
              <el-input v-model="dialogForm.detailAddress" placeholder="请输入详细地址"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="submitDialogForm()" size="mini" type="primary" v-show="dialogForm.status != 2">提交审核</el-button>
        <el-button @click="submitDialogForm()" size="mini" type="primary" v-show="dialogForm.status == 2">保存</el-button>
        <el-button @click="handleCloseDialog" size="mini">取 消</el-button>
      </div>
    </el-dialog>
    <customer-service-component></customer-service-component>
  </div>
</template>

<script>
import MixinCUD from "../../components/MixinCUD";
import {getAllShopType} from "../../api/b2cbusiness/b2c_shoptype";
import {getAllShopMajorType} from "../../api/b2cbusiness/b2c_shopmajortype";
import {getAllShops, getShops, addShop, updateShop} from "../../api/b2cbusiness/b2c_shopmanage";
import {getProvinceCityCountry, isObjectEmpty} from "../../lib/utils";
import VDistpicker from 'v-distpicker';
import CustomerServiceComponent from "../../components/CustomerServiceComponent";
import MinxinScroll from "@/components/MinxinScroll";
import {getTaobaoAuthorInfo, getTaobaoAuthorUrl} from "@/api/b2cbusiness/b2c_tasklist";

export default {
  name: "StoreManagelist",
  mixins: [MixinCUD, MinxinScroll],
  components: {
    VDistpicker,
    CustomerServiceComponent
  },
  data() {
    return {
      tableHeight: 450,
      options:[
        {
          label:"0(灰色)",
          value:0
        },
        {
          label:"1(红色)",
          value:1
        },
        {
          label:"2(黄色)",
          value:2
        },
        {
          label:"3(绿色)",
          value:3
        },
        {
          label:"4(蓝色)",
          value:4
        },
        {
          label:"5(粉红色)",
          value:5
        },
      ],
      tableData: [],
      ShopOptions: [],
      majorTypeOptions: [],
      queryForm:{},
      dialogFormVisible: false,
      dialogTitle:"",
      dialogRefName:"dialogForm",
      dialogForm: {
        shopMajorTypeId: "",
        shopTypeId: "",
        shopUsername: "",
        shopName: "",
        shopNum:"",
        shopUrl: "",
        shopGroup: "",
        rebuyDays: "",
        province: "省",
        city: "市",
        area: "区",
        persionName: " ",
        persionPhone: " ",
        persionZip: " ",
        address: " ",
        detailAddress: ""
      },
      dialogFormRules: {
        shopTypeId: [
          {required: true, message: '请选择店铺类型', trigger: 'blur'},
        ],
        shopMajorTypeId: [
          {required: true, message: '请选择主营类目', trigger: 'blur'},
        ],
        shopUsername: [
          {required: true, message: '请输入掌柜名称', trigger: 'blur'},
        ],
        shopName: [
          {required: true, message: '请输入店铺名称', trigger: 'blur'},
        ],
        shopUrl: [
          {required: true, message: '请输入正确的域名', trigger: 'blur'},
        ],
        persionName: [
          {required: true, message: '请输入发货联系人', trigger: 'blur'},
        ],
        persionPhone: [
          {pattern: /^1[3456789]\d{9}$/, message: '目前只支持中国大陆的手机号码', trigger: 'blur'}
        ],
      },
      pagination: {
        pageNum: 1,
        pageSize: 20,
        total: null
      },
    }
  },
  created() {
    this.tableHeight = document.documentElement.clientHeight - 320;
    //console.log(document.body.clientHeight, this.tableHeight)
  },
  computed:{
  },
  mounted() {
    getAllShopType().then(res => {
      console.log(res.data);
      this.ShopOptions = res.data;
    });

    getAllShopMajorType().then(res => {
      console.log(res.data);
      this.majorTypeOptions = res.data;
    });

    getAllShops().then(res => {
      console.log(res.data)
      this.tableData = res.data;
    });
  },
  methods: {
    confirmAsscetAuthor(){
      getTaobaoAuthorUrl().then(res=>{
        if (res.success){
          this.$confirm("请确认先购买:《打单发货王》,购买地址："+res.data.help_url).then(_=>{
              window.open(res.data.authorization_address, '_blank');
          })
        }
      });
    },
    onSelected(data) {
      console.log(data)
      this.dialogForm.address = data.province.value.concat(data.city.value);
      this.dialogForm.address = this.dialogForm.address.concat(data.area.value);
      console.log(this.dialogForm);
    },

    getData() {
      getShops({shopNum:null,
        shopName:null,
        shopUsername:null,
        shopType: null,
        shopMajorTypeId:null,
        status:null,
        shopGroup:null}, this.pagination).then(res => {
          this.setData(res)
      });
    },

    addData() {
      console.log(this.dialogForm);
      /*
      addressInfo: {
            persionName: " ",
            persionPhone: " ",
            persionZip: " ",
            address: " ",
            detailAddress: ""
      },
      */
      this.dialogForm.address = this.dialogForm.address.concat(this.dialogForm.detailAddress);
      this.dialogForm.addressInfo = {
        persionName: this.dialogForm.persionName,
        persionPhone: this.dialogForm.persionPhone,
        persionZip: this.dialogForm.persionZip,
        address: this.dialogForm.address,
        detailAddress: this.dialogForm.detailAddress
      }
      addShop(this.dialogForm).then(res => {
        if (res.success){
        this.$message({message: res.data, type: 'success'});
        this.submitQueryForm();//新增之后，重新查询table
        this.handleCloseDialog();
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
        this.handleCloseDialog();
      });
    },
    setData(pageinfo) {
      if (pageinfo.success) {
        console.log(pageinfo)
        this.tableData = pageinfo.data
      }
    },
    updateData(){
      console.log("updateData", this.dialogForm);
      this.dialogForm.addressInfo = {
        persionName: this.dialogForm.persionName,
        persionPhone: this.dialogForm.persionPhone,
        persionZip: this.dialogForm.persionZip,
        address: this.dialogForm.address,
        detailAddress: this.dialogForm.detailAddress
      }
      updateShop(this.dialogForm).then(res =>{
        console.log(res.data)
        if (res.success){
        this.$message({message: res.data, type: 'success'});
        this.submitQueryForm();//修改之后，重新查询table
        this.handleCloseDialog();
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
        this.handleCloseDialog();
      });
    },

    getShopType(shoTypeId) {
      for (let i in this.ShopOptions) {
        console.log(i);
        if (this.ShopOptions[i].id == shoTypeId) {
          return this.ShopOptions[i].shopType;
        }
      }
      return "";
    },

    locationHandleEdit(index, row, dialogTitle) {
      console.log("------", row);
      /*
      if (row.addressInfo != null && row.addressInfo.address !== "") {
        this.dialogForm.province = getProvinceCityCountry(row.address)[0];
        this.dialogForm.city = getProvinceCityCountry(row.address)[1];
        this.dialogForm.area = getProvinceCityCountry(row.address)[2];
      }
       */
      console.log(this.dialogForm);

      row.persionName = row.addressInfo.persionName;
      row.persionPhone = row.addressInfo.persionPhone;
      row.persionZip = row.addressInfo.persionZip;
      row.address = row.addressInfo.address
      //row.detailAddress = row.addressInfo.detailAddress;
      if (row.id != null && row.status != 2){
        row.status = 1;
      }

      if (this.dialogForm == null){
        this.dialogForm = row;
      }
      this.dialogForm.address = this.dialogForm.address.concat(this.dialogForm.detailAddress);
      this.handleEdit(index, row, dialogTitle);
    }
  }
}
</script>

<style scoped>
.el-table {
  margin-top: 10px;
}
</style>
